// extracted by mini-css-extract-plugin
export default {"container":"Expenses_container__1dtmV"};